export const webviewRoutesArray = [
  {
    path: 'cashbox/:type/:payment_id',
    name: 'webview-cashbox',
    meta: { auth: true },
    component: () => import('pages/CashboxPage.vue'),
  },
  {
    path: 'sport',
    name: 'webview-sport',
    component: () => import('pages/SportsWebview.vue'),
  },
]
